<style scoped>
.layout-app-bar {
  height: 30px;
}
</style>

<template>
  <div>
    <div v-if="canEdit">
      <mu-button color="primary" @click="onAddItem"><mu-icon value="add" />{{$t('timeCapsule.add')}}</mu-button>
      <div v-for="(item, index) in data" :key="index">
        <mu-appbar class="full-width layout-app-bar" color="secondary">
          <mu-button icon slot="left" @click="onToggleItem(index)">
            <mu-icon :value="data[index].enabled ? 'visibility' : 'visibility_off'"></mu-icon>
          </mu-button>
          <mu-button icon slot="right" @click="onDeleteItem(index)">
            <mu-icon value="delete"></mu-icon>
          </mu-button>
          <mu-button icon slot="right" @click="onCollapseItem(index)">
            <mu-icon :value="data[index].collapsed ? 'expand_more' : 'expand_less'"></mu-icon>
          </mu-button>
          <small>{{tooltipFormatter(data[index].interval[0])}} ~ {{tooltipFormatter(data[index].interval[1])}}</small>
        </mu-appbar>
        <mu-card v-if="!data[index].collapsed">
          <div>
            <VueSlider
              v-model="data[index].interval"
              v-bind="sliderOptions"
              @callback="onUpdateItem"
              />
          </div>
          <mu-text-field v-model="data[index].content" full-width @change="onUpdateItem"></mu-text-field>
        </mu-card>
      </div>
    </div>
    <div v-else>
      <div v-for="(item, index) in data" :key="index">
        <transition-group tag="div" name="list-complete">
          <mu-card v-if="isShow(index)" :key="index" class="list-complete-item">
            <mu-card-text v-html="data[index].content" />
          </mu-card>
        </transition-group>
      </div>
    </div>
  </div>
</template>

<script>
// Data
import defaultData from './data.json'

// Library
import VueSlider from 'vue-slider-component';
import axios from "axios";

// Utils
import timeFormatter from '@/utils/timeFormatter.js'

export default {
  name: 'TimeCapsulePanel',
  components: {
    VueSlider,
  },
  props: {
    media: {
      type: Object,
      required: true
    },
    mediaId: {
      type: String
    },
    currentTime: {
      type: Number,
      required: true
    },
    isAdmin: {
      type: Boolean
    },
  },
  data() {
    return {
      data: [],
      sliderOptions: {
        data: null,
        eventType: 'auto',
        width: 'auto',
        height: 6,
        dotSize: 16,
        dotHeight: null,
        dotWidth: null,
        min: 0,
        max: this.media.duration,
        interval: 1,
        show: true,
        speed: 0.5,
        disabled: false,
        piecewise: false,
        usdKeyboard: false,
        enableCross: true,
        piecewiseStyle: false,
        piecewiseLabel: false,
        tooltip: 'hover',
        tooltipDir: 'top',
        reverse: false,
        clickable: true,
        realTime: false,
        lazy: false,
        formatter: this.tooltipFormatter,
        bgStyle: null,
        sliderStyle: null,
        processStyle: null,
        piecewiseActiveStyle: null,
        tooltipStyle: null,
        labelStyle: null,
        labelActiveStyle: null
      }
    }
  },
  computed: {
    // Store
    triggerRefresh() {
      return this.$store.getters.triggerRefresh;
    },

    // Flag
    isPreview() {
      if(this.$store.getters.previewMode) {
        return true;
      } else {
        return false;
      }
    },
    canEdit() {
      return !this.isPreview && this.isAdmin;
    },
  },
  watch: {
    mediaId() {
      this.data = JSON.parse(JSON.stringify(this.media.timeCapsule));
    },
  },
  created() {
    if(this.media.hasOwnProperty('timeCapsule')) {
      this.data = JSON.parse(JSON.stringify(this.media.timeCapsule));
    }
  },
  mounted() {
    this.initEditor();
  },
  methods: {
    onAddItem() {
      var data = JSON.parse(JSON.stringify(defaultData));
      this.data.push(data);
      this.onUpdateItem();
    },
    onDeleteItem(index) {
      this.data.splice(index, 1);
      this.onUpdateItem();
    },
    onCollapseItem(index) {
      if(this.data[index].hasOwnProperty('collapsed')) {
        if(this.data[index].collapsed)
          this.$set(this.data[index], 'collapsed', false);
        else
          this.$set(this.data[index], 'collapsed', true);
      } else {
        this.$set(this.data[index], 'collapsed', true);
      }
    },

    tooltipFormatter(value) {
      return timeFormatter(value);
    },

    onUpdateItem() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.onUpdateTimeCapsule();
      }, 1000);
    },
    onUpdateTimeCapsule() {
      axios.put(this.$store.getters.urlApi + "media/" + this.media._id, {
          timeCapsule: this.data
        }, {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(() => {
        this.$store.commit("triggerRefresh");
        this.$emit('onUpdateMedia', {
          index: 'timeCapsule',
          data: this.data
        })
        this.$toast.success(this.$t('toast.edit'));
      });
    },

    isShow(index) {
      var start = this.data[index].interval[0];
      var end = this.data[index].interval[1];
      if(start <= this.currentTime && this.currentTime <= end) {
        return true;
      } else {
        return false;
      }
    },
  },
}
</script>

<style scoped>
.editor {
  
}
</style>